import { useState } from "react";
import { useSelector } from "react-redux";
import AiAskPlace from "@shared/AiAssistant/AiAskPlace";
import Snackbar from "@shared/v2/Snackbar";
import Help from "./HelpDropdown";
import FeatureToggle from "./FeatureToggle";
import GlobalStatus from "../GlobalStatus";
import SuperUser from "../SuperUser";
import MetaUser from "../MetaUser";
import UserDropdown from "./UserDropdown";
import Logo from "./Logo";
import MobileHamburger from "./MobileHamburger";
import Resources from "./Resources";
import { useCurrentUser, useFeatureFlags } from "../../reducers/layoutReducer/selectors";
import QuickSearch from "../../QuickSearch/components/QuickSearch";
import ActivitiesFeed, { isActivityFeedPinnedOpen } from "./ActivitiesFeed";
import { useSnackbar } from "../../reducers/snackbarReducer";
import ReferAFriend from "./ReferAFriend";
import SingleDialerModal from "../../Dialer/SingleDialerModal";
import ConferenceCall from "../../Interactions/ConferenceCall/ConferenceCall";
import RemoveRoutingNumberModal from "../../Contacts/RemoveRoutingNumberModal";
import DayInTheLife from "./DayInTheLife/DayInTheLife";

const Header = () => {
  const currentUser = useCurrentUser();
  const featureFlags = useFeatureFlags();
  const asSuper = useSelector(({ layout }) => layout.asSuper);
  const snackbar = useSnackbar();
  const [openDrawer, setOpenDrawer] = useState(() => (isActivityFeedPinnedOpen() ? "activityFeed" : null));

  const drawerProps = (name) => ({
    open: openDrawer === name,
    onOpenChange: (open) =>
      setOpenDrawer((prev) => {
        if (open) return name;
        return prev === name ? null : prev;
      }),
  });

  return (
    <>
      <SuperUser />
      <MetaUser />
      <SingleDialerModal />
      <ConferenceCall />
      <RemoveRoutingNumberModal />
      <GlobalStatus />
      {!asSuper && (
        <>
          <Snackbar
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...snackbar}
          />
          <header className="tw-sticky tw-top-0 tw-z-1000 tw-text-neutral-gray-50 tw-px-[20px] tw-pt-[8px] tw-flex tw-gap-[16px] tw-justify-between tw-items-center">
            <div className="tw-flex tw-gap-[16px] tw-items-center">
              <MobileHamburger />
              <Logo />
            </div>

            <div className="bs-xs:tw-hidden tw-min-w-[200px] tw-max-w-[600px] tw-flex-1 tw-flex tw-items-center">
              {currentUser?.account.uuid && featureFlags.askPlace && (
                <div className="tw-mr-[8px] tw-my-[-2px]">
                  <AiAskPlace />
                </div>
              )}

              {currentUser?.account.uuid && featureFlags.quicksearch && (
                <div className="tw-flex-1">
                  <QuickSearch />
                </div>
              )}
            </div>

            <div className="tw-flex tw-gap-[16px] tw-items-center">
              <FeatureToggle />
              {currentUser?.account.uuid && (
                <div className="tw-flex tw-gap-[8px] tw-items-center">
                  <ReferAFriend />
                  <Help />
                  <Resources />
                </div>
              )}
              <div className="tw-flex-none tw-w-[1px] tw-h-[20px] tw-bg-gray-15" />
              <div className="tw-flex tw-gap-[8px] tw-items-center">
                {currentUser?.account.uuid && (
                  <ActivitiesFeed
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...drawerProps("activityFeed")}
                  />
                )}
                {featureFlags.ditlV1 && (
                  <DayInTheLife
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...drawerProps("dayInTheLife")}
                  />
                )}
                <UserDropdown />
              </div>
            </div>
          </header>
        </>
      )}
    </>
  );
};

export default Header;
